import styled from 'styled-components';

export const DataTimeWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 5px;
`;

export const TimeWrapper = styled.span`
    font-size: 12px;
    color: #676767;
    display: flex;
`;

export const Date = styled.div`
    display: flex;
    gap: 2px;
    align-items: center;
    justify-content: center;
    margin: 0 3px;
`;
